import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styles from './styles/header-menu.scss';
import APP_ROUTES from '../../../constants/app-routes';

import bannerImage from '../../../images/banner03.png';
import ZoneSelectConnector from '../../../containers/zone-select-connector';
import MunicipalityService from '../../../services/municipality-service';
import spreeStore from '../../../store';
import MunicipalitySelectorModal from '../municipality-selector-modal';
import actions from '../../../actions';
import ProductModel from '../../../services/product-model';

class HeaderMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            elementHover: '',
            showZoneSelector: false,
            showMunicipalitySelector: false,
            selectedZoneMunicipalities: [],
        };

        this.toggleUserMenu = this.toggleUserMenu.bind(this);
        this.manageZoneSelected = this.manageZoneSelected.bind(this);
    }

    async componentDidMount() {
        await this.props.triggerInitialSetup(this.props.locale.currentLocale, this.props.currentStore, this.props.order);
        if (this.props.currentZone === undefined) {
            this.setState({
                showZoneSelector: true,
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    componentDidUpdate(prevProps) {
        const selectedZoneMunicipalities = MunicipalityService.getAvailableMunicipalitiesByZoneId(
            this.props.currentZone,
            this.props.availableZones,
            this.props.availableMunicipalities,
        );
        if (MunicipalityService.isMunicipalitySelectorModalRequired(this.props.currentMunicipality, selectedZoneMunicipalities)) {
            if (!this.props.isMunicipalityPromptModalOpen && !this.state.showMunicipalitySelector) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    showMunicipalitySelector: true,
                    selectedZoneMunicipalities,
                });
            }
        } else if (this.props.currentZone && selectedZoneMunicipalities.length === 0) {
            this.props.setCurrentMunicipality(undefined);
        }
    }

    manageZoneSelected(zoneId) {
        this.setState({
            showZoneSelector: false,
        });
    }

    toggleUserMenu(element) {
        this.setState({ elementHover: element });
    }

    handleSelectedMunicipality(municipality) {
        this.props.setCurrentMunicipality(municipality.id);
        this.setState({
            showMunicipalitySelector: false,
        });
        const { locale: currentLocale } = spreeStore.getState();
        spreeStore.dispatch(actions.displayLoader());
        spreeStore.dispatch(actions.fetchProducts({ page_no: 1, currentLocale })).then((response) => {
            const fetchedProducts = response.body;
            spreeStore.dispatch(actions.addProducts({ products: ProductModel.filterUniqueProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
            spreeStore.dispatch(actions.hideLoader());
        });
    }

    render() {
        const menuLevel2 = (taxons) => taxons.map((taxon, index) => (
            <li key={taxon.id} className={`dropdown ${styles.menuDropdownLevel2}`} onClick={() => this.toggleUserMenu('')} onMouseEnter={() => this.toggleUserMenu(taxon.attributes.permalink)}>
                <Link to={`${APP_ROUTES.searchPageRoute}?category=${taxon.attributes.permalink}`}>
                    {taxon.attributes.name}
                    {taxon.taxons.length > 0 && (
                        <i
                            className={`pe-7s-angle-right pe-1x pe-va ${styles.angleDown}`}
                            style={{ display: `${this.state.elementHover.split('/')[0]}/${this.state.elementHover.split('/')[1]}` === taxon.attributes.permalink ? 'none' : 'inline-block' }}
                        />
                    )}
                    {taxon.taxons.length > 0 && (
                        <i
                            className={`pe-7s-angle-left pe-1x pe-va ${styles.angleUp}`}
                            style={{ display: `${this.state.elementHover.split('/')[0]}/${this.state.elementHover.split('/')[1]}` === taxon.attributes.permalink ? 'inline-block' : 'none' }}
                        />
                    )}
                </Link>
            </li>
        ));

        const menuKatapulkLevel2 = (taxons, storeIdParam) => taxons.map((taxon) => (
            <li key={taxon.id} className={`dropdown ${styles.menuDropdownLevel2}`} onClick={() => this.toggleUserMenu('')} onMouseEnter={() => this.toggleUserMenu(taxon.permalink)}>
                <Link to={`${APP_ROUTES.searchPageRoute}?category=${taxon.permalink}&${storeIdParam}`}>
                    {taxon.name}
                </Link>
            </li>
        ));

        const menuKatapulkLevel1 = (taxons, storeIdParam) => taxons.map((taxon) => (
            // eslint-disable-next-line max-len
            <li key={taxon.taxonCategory.id} className={`dropdown ${styles.menuDropdownLevel1}`} onClick={() => this.toggleUserMenu('')} onMouseEnter={() => this.toggleUserMenu(taxon.taxonCategory.permalink)}>
                <Link to={`${APP_ROUTES.searchPageRoute}?category=${taxon.taxonCategory.permalink}&${storeIdParam}`}>
                    {taxon.taxonCategory.name}
                    {taxon.taxons.length > 0 && (
                        <i
                            className={`pe-7s-angle-right pe-1x pe-va ${styles.angleDown}`}
                            style={{ display: `${this.state.elementHover.split('/')[0]}/${this.state.elementHover.split('/')[1]}` === taxon.taxonCategory.permalink ? 'none' : 'inline-block' }}
                        />
                    )}
                    {taxon.taxons.length > 0 && (
                        <i
                            className={`pe-7s-angle-left pe-1x pe-va ${styles.angleUp}`}
                            style={{ display: `${this.state.elementHover.split('/')[0]}/${this.state.elementHover.split('/')[1]}` === taxon.taxonCategory.permalink ? 'inline-block' : 'none' }}
                        />
                    )}
                </Link>
                {taxon.taxons.length > 0 && (
                    <ul
                        className={`dropdown ${styles.menuSubCategories}
                    ${`${this.state.elementHover.split('/')[0]}/${this.state.elementHover.split('/')[1]}` === taxon.taxonCategory.permalink ? styles.menuSubCategoriesHover : ''}`}
                    >
                        <li key={taxon.id} className={`row ${styles.menuDropdownLevel2}`} onMouseEnter={() => this.toggleUserMenu(taxon.taxonCategory.permalink)}>
                            <ul className={styles.tableCell}>
                                {menuKatapulkLevel2(taxon.taxons.slice(0, taxon.taxons.length / 2 + 1), storeIdParam)}
                            </ul>
                            <ul className={styles.tableCell}>
                                {menuKatapulkLevel2(taxon.taxons.slice(taxon.taxons.length / 2 + 1), storeIdParam)}
                            </ul>
                        </li>
                        <li className={styles.specialGifts}>
                            <a role="button">
                                <img className="pull-right" src={bannerImage} alt="Banner" />
                                <p className={styles.titleSection}>
                                    <FormattedMessage id="do-you-need" defaultMessage="Do you need" />
                                    <br />
                                    <FormattedMessage id="a-special-gift" defaultMessage="a special gift?" />
                                </p>
                            </a>
                        </li>
                    </ul>
                )}
            </li>
        ));

        const getStore = (id) => this.props.stores.find((item) => {
            if (id && item.id) {
                return item.id === id;
            }
            return undefined;
        });

        return (
            <nav
                className={`navbar-collapse navbar-left collapse ${styles.navBar}`}
                id="kk-navbar-collapse"
                style={{ height: '1px' }}
            >
                <ZoneSelectConnector
                    show={this.state.showZoneSelector}
                    onHide={this.manageZoneSelected}
                />
                <MunicipalitySelectorModal
                    isOpen={this.state.showMunicipalitySelector}
                    currentZoneMunicipalities={this.state.selectedZoneMunicipalities}
                    handleClose={(municipality) => this.handleSelectedMunicipality(municipality)}
                />
            </nav>
        );
    }
}

export default HeaderMenu;



/** WEBPACK FOOTER **
 ** ./src/components/shared/header/header-menu.jsx
 **/